import { tokenUrl } from 'config';
import createRequest from '../create-request';

const request = createRequest({ label: 'auth' });

const isAuthenticated = cookies => typeof cookies['.ASPXAUTH'] !== 'undefined';

const token = () => request
  .get(tokenUrl)
  .withCredentials()
  .then(response => {
    const { IssuedToken } = response.body;
    return IssuedToken ?
      { token: `SWS ${IssuedToken}` } :
      Promise.reject({ status: 401, message: 'Not Authorized' });
  });

export default {
  isAuthenticated,
  token
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/seek-jobs-api-client/apis/authentication.js
 **/